import { useLocation } from "react-router-dom";
import classes from "./contact.module.css";
import contactus from "../../assets/illustrations/contact-us.png";
import { HomeIcon, MailIcon, PhoneFillIcon } from "../../constants/svg";
import LandingFooter from "../../components/Landing/Footer/footer";
import Footer from "../../components/Onboarding/Footer/footer";
import Navbar from "../../components/Landing/components/Navbar/Navbar";

const ContactUsPage = () => {

  return (
    <>
      <Navbar />
      <div className={classes.main}>
        <div className={classes.container}>

          <div className={classes.formSection}>
            <div className={classes.textSection}>
              <h2 className="">Contact Us</h2>
              <p className={classes.addressGroup}>
                <HomeIcon />1 Adebiyi Mobolaji street, Marcus Poli estate, Kafe
                District Abuja 900001
              </p>

              <div className={classes.addressGroup}>
                <MailIcon />
                <ul>
                  <li>
                    <a href="mailto:info@awasource.com">info@awasource.com</a>
                  </li>
                  <li>
                    <a href="mailto:support@awasource.com">
                      support@awasource.com
                    </a>
                  </li>
                </ul>
              </div>
              <div className={classes.addressGroup}>
                <PhoneFillIcon />
                <ul>
                  <li>
                    <a href="tel:07039521917"> 07039521917</a>
                  </li>
                  <li>
                    <a href="tel:09031553585"> 09031553585</a>
                  </li>
                </ul>
              </div>
            </div>


          <div className={classes.banner}>
            <div>
              <img src={contactus} alt="Contact Us Banner" />
            </div>
          </div>
          </div>

        </div>
      </div>
      <LandingFooter />
      <Footer />
    </>
  );
};

export default ContactUsPage;
